export default __webpack_public_path__ + "static/media/fullscreen.04a7aa38.svg";